// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { WinaTvRed } from '../../assets/svg/common';
import { SpecialFilterValues } from '../../constants/livebar';
import { type FacetType } from '../../types/facets';
import LiveBar from '../LiveBar';
import SportIcon from '../SportIcon';

const StyledSportIcon = styled(SportIcon)`
  color: white;
`;

type MatchRowsFiltersBarProps = {
  facets: Array<FacetType>;
  selectedSportIds: Array<number>;
  onClickItem: (sportId: number) => void;
  className?: string;
};

const MatchRowsFiltersBar = ({ facets, selectedSportIds, onClickItem, className }: MatchRowsFiltersBarProps) => {
  const filterItems = useMemo(
    () => [
      ...facets.map((sport) => ({
        ...sport,
        icon:
          sport.id === SpecialFilterValues.WINAMAX_TV_FILTER ? <WinaTvRed /> : <StyledSportIcon sportId={sport.id} />,
        selected: selectedSportIds?.indexOf(sport.id) !== -1,
      })),
    ],
    [facets, selectedSportIds],
  );

  return <LiveBar className={className} items={filterItems} onClickItem={onClickItem} />;
};

export default MatchRowsFiltersBar;
